<template>
  <v-card v-if="faresItems.length > 0">
    <v-data-table :headers="headers" :items="faresItems" :pagination.sync="pag">
      <template v-slot:items="props">
        <td class="text-xs-center text-md-center text-lg-center">
          {{ props.item.created_at | formatarDate }}
        </td>
        <td class="text-xs-center text-md-center text-lg-center">
          {{ props.item.agent_email }}
        </td>
        <td class="text-xs-center text-md-center text-lg-center">
          {{ props.item.competence }}
        </td>
        <td class="text-xs-center text-md-center text-lg-center">
          {{ props.item.utility_company | toUpperCase }}
        </td>
        <td class="text-xs-center text-md-center text-lg-center">
          {{ props.item.kwh_value }}
        </td>
        <td class="text-xs-center text-md-center text-lg-center">
          {{ props.item.item }}
          <v-icon small class="ml-2 pl-2" @click="getFares(props.item)"
            >visibility</v-icon
          >
        </td>
      </template>

      <template v-slot:no-data>
        <v-alert :value="true" color="error" icon="warning">
          Sem dados para exibir.
        </v-alert>
      </template>
    </v-data-table>

    <v-snackbar :color="color" top v-model="snackbar" dark>
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
    <FaresModal
      v-if="showFaresModal"
      :key="key"
      :import_fare="fare"
      type="view"
      :showFaresDialog="showFaresModal"
      @closeDialog="closeDialog"
    />
  </v-card>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      headers: [
        { text: "Cadastrado em", align: "center", value: "created_at" },
        { text: "Cadastrado por", align: "center", value: "agent_email" },
        { text: "Competência", align: "center", value: "competence" },
        { text: "Concessionária", align: "center", value: "utility_company" },
        { text: "Valor da Tarifa", align: "center", value: "kwh_value" },
      ],
      pag: {
        itemsPerPage: 50,
      },
      color: null,
      snackMessage: null,
      snackbar: false,
      showFaresModal: false,
      fare: {},
      key: 0,
    };
  },

  filters: {
    toUpperCase(value) {
      if (!value) return "";
      return value.toString().toUpperCase();
    },
  },

  computed: {
    ...mapState("billing", ["faresItems", "loading"]),
    ...mapState(["user", "permissions"]),

    isAdmin() {
      let currentUserGroups = this.user.group.toString();
      return currentUserGroups.indexOf("admin") >= 0;
    },

    isFinancial() {
      let currentUserGroups = this.user.group.toString();
      return currentUserGroups.indexOf("financial") >= 0;
    },

    isPartnerManagement() {
      let currentUserGroups = this.user.group.toString();
      return currentUserGroups.indexOf("partner_management") >= 0;
    },
  },

  components: {
    FaresModal: () => import("./FaresModal"),
  },

  methods: {
    getFares(item) {
      this.fare = { ...item };
      this.key += 1;
      this.showFaresModal = true;
    },

    closeDialog() {
      this.showFaresModal = false;
    },

    snack(message, color, snackbar) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = snackbar;
    },

    showSnack(text, color) {
      this.snack(text, color);
    },
  },
};
</script>

<style lang="scss">
#core-view
  > div
  > div:nth-child(3)
  > div
  > div
  > div
  > div
  > div
  > div.v-datatable.v-table.theme--light
  > div
  > div.v-datatable__actions__range-controls
  > button:nth-child(2)
  > div
  > i,
#core-view
  > div
  > div:nth-child(3)
  > div
  > div
  > div
  > div
  > div
  > div.v-datatable.v-table.theme--light
  > div
  > div.v-datatable__actions__range-controls
  > button:nth-child(3)
  > div
  > i {
  color: #000 !important;
}

#core-view
  > div
  > div:nth-child(3)
  > div
  > div
  > div
  > div
  > div
  > div.v-datatable.v-table.theme--light
  > div
  > div.v-datatable__actions__range-controls
  > button.v-btn.v-btn--disabled.v-btn--flat.v-btn--icon.theme--light
  > div
  > i {
  color: #bebebe !important;
}
</style>
